import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Bulk Send Org Member Invitations Request Schema
 * POST /api/v2/org-member/bulk-send-invitations
 *
 * The client sends the explicit ids of the inactive rows it is showing so the
 * action invites exactly what's on screen. The server re-validates each id.
 */ export const BulkSendOrgMemberInvitationsRequestSchema = z.object({
    userIds: z.array(z.string().min(1)).min(1)
});
/**
 * Bulk Send Org Member Invitations Response Schema
 * POST /api/v2/org-member/bulk-send-invitations
 *
 * Reports which ids were invited and which were skipped (with the reason as an
 * `ErrorCode`, e.g. the id no longer exists or is no longer invitable).
 */ export const BulkSendOrgMemberInvitationsResponseSchema = z.object({
    data: z.object({
        invitedUserIds: z.array(z.string()),
        skipped: z.array(z.object({
            userId: z.string(),
            errorCode: z.enum(ErrorCode)
        }))
    })
});

//# sourceMappingURL=bulk-send-org-member-invitations.schema.js.map